module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-list', [_c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "title": _vm.$t('message.notificationPreferencesQuestionReplies')
    },
    on: {
      "click": function($event) {
        _vm.model.answer = !_vm.model.answer
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#767676"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.notificationPreferencesQuestionRepliesSubLine')) + "\n        ")]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.answer),
      callback: function($$v) {
        _vm.$set(_vm.model, "answer", $$v)
      },
      expression: "model.answer"
    }
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "title": _vm.$t('message.notificationPreferencesNewFollower')
    },
    on: {
      "click": function($event) {
        _vm.model.follow = !_vm.model.follow
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#767676"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.notificationPreferencesNewFollowerSubLine')))]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.follow),
      callback: function($$v) {
        _vm.$set(_vm.model, "follow", $$v)
      },
      expression: "model.follow"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-card-text', [_c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "secondary": "",
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.snackbar) ? _c('mu-snackbar', {
    attrs: {
      "message": "Updated notification preferences",
      "action": "Ok"
    },
    on: {
      "actionClick": _vm.hideSnackbar,
      "close": _vm.hideSnackbar
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa12a678","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Notifications.vue
// module id = 3873
// module chunks = 1